import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "title title--h3" }, " Создание задачи ", -1)

import BasicTextarea from '@/components/UI/BasicTextarea.vue';
import BasicRadio from '@/components/UI/BasicRadio.vue';
import BasicCheckbox from '@/components/UI/BasicCheckbox.vue';
import BasicDatepicker from '@/components/UI/BasicDatepicker.vue';
import BasicButton from '@/components/UI/BasicButton.vue';
import { reactive } from 'vue';
import EditTask from '@/types/editTask';
import { Task, taskDefaults } from '@/types/task';
import { v4 as uuidv4 } from "uuid";
import { useForm, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskForm',
  props: {
    initialData: {}
  },
  emits: ["addTask", "editTask"],
  setup(__props: any, { emit }) {

const props = __props;





const formData = reactive<EditTask>({
  id: props.initialData && props.initialData.id ? props.initialData.id : null,
  date: props.initialData && props.initialData.date ? props.initialData.date : new Date(Date.now()),
  title: props.initialData && props.initialData.title ? props.initialData.title : null,
  importance: props.initialData && props.initialData.importance ? props.initialData.importance : null,
  access: props.initialData && props.initialData.access ? props.initialData.access : null,
  btnTitle: props.initialData && props.initialData.btnTitle ? props.initialData.btnTitle : 'Создать',
  ...taskDefaults
});

const { handleSubmit } = useForm({
  validationSchema: yup.object({
    title: yup.string().min(3, 'Слишком короткое название').max(255, 'Слишком длинное название').required('Обязательное поле'),
    importance: yup.number().nonNullable().required('Обязательное поле'),
    date: yup.date().min(new Date(Date.now() + 3600),"Задачу надо не позднее чем за час!").required('Обязательное поле'),
  }),
  initialValues: formData,
});

const formDescription = {
  groupLabel: 'Введите время и описание',
  datepicker: {
    label: 'Дата:',
    id: uuidv4(),
    name: 'date',
  },
  input: {
    label: 'Описание:',
    id: uuidv4(),
    name: 'title',
  },
  checkbox: {
    groupLabel: 'Персональная (по умолчанию) или групповая задача',
    group: {
        label: 'Групповая',
        id: uuidv4(),
        name: 'access',
        value: 'all',
        checked: false
      }
  },
  radio: {
    groupLabel: 'Важность',
    group: [
      {
        label: 'Высокая',
        id: uuidv4(),
        name: 'importance',
        value: 3,
      },
      {
        label: 'Средняя',
        id: uuidv4(),
        name: 'importance',
        value: 2
      },
      {
        label: 'Низкая',
        id: uuidv4(),
        name: 'importance',
        value: 1
      },
    ]
  }
};

const { groupLabel, datepicker, input, radio, checkbox } = formDescription;

const onSubmit = handleSubmit((values, { resetForm }) => {
  addTask(values);
  resetForm();
});

const addTask = (values) => {
  if (!props.initialData) {
    let newTask: Task = {
      id: 'temporal-will-be-rewritten-by-firebase',
      date: values.date,
      title: values.title,
      importance: values.importance,
      access: values.access,
      ...taskDefaults
    }

    emit('addTask', newTask);
  } else {
    let editingTask: Task = {
      id: formData.id,
      date: values.date,
      title: values.title,
      importance: values.importance,
      access: values.access,
      ...taskDefaults
    }

    emit('editTask', editingTask);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", null, _toDisplayString(_unref(groupLabel)), 1),
      _createVNode(BasicDatepicker, {
        id: _unref(datepicker).id,
        label: _unref(datepicker).label,
        name: _unref(datepicker).name
      }, null, 8, ["id", "label", "name"]),
      _createVNode(BasicTextarea, {
        id: _unref(input).id,
        name: _unref(input).name,
        label: _unref(input).label
      }, null, 8, ["id", "name", "label"])
    ]),
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", null, _toDisplayString(_unref(checkbox).groupLabel), 1),
      (_openBlock(), _createBlock(BasicCheckbox, {
        id: _unref(checkbox).group.id,
        key: _unref(checkbox).group.id,
        checkboxvalue: _unref(checkbox).group.value,
        checked: _unref(checkbox).group.checked,
        label: _unref(checkbox).group.label,
        name: _unref(checkbox).group.name
      }, null, 8, ["id", "checkboxvalue", "checked", "label", "name"])),
      _createVNode(_unref(ErrorMessage), {
        class: "error",
        name: _unref(radio).group[0].name
      }, null, 8, ["name"])
    ]),
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", null, _toDisplayString(_unref(radio).groupLabel), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(radio).group, (el) => {
        return (_openBlock(), _createBlock(BasicRadio, {
          id: el.id,
          key: el.id,
          radiovalue: el.value,
          label: el.label,
          name: el.name
        }, null, 8, ["id", "radiovalue", "label", "name"]))
      }), 128)),
      _createVNode(_unref(ErrorMessage), {
        class: "error",
        name: _unref(radio).group[0].name
      }, null, 8, ["name"])
    ]),
    _createVNode(BasicButton, { type: "submit" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(formData.btnTitle), 1)
      ]),
      _: 1
    })
  ], 32))
}
}

})